module.exports = __webpack_public_path__ + "static/img/1016_big.2296259.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1016_big.png
// module id = Cq0r
// module chunks = 1